import { Omit, StyleRulesCallback } from '@material-ui/core';
import Button, {
  // @ts-ignore
  styles as buttonStyles,
  ButtonClassKey,
  ButtonProps,
} from '@material-ui/core/Button/Button';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, {
  StyleRules,
  WithStyles,
} from '@material-ui/core/styles/withStyles';
import deepmerge from 'deepmerge';
import React, { FunctionComponent } from 'react';
import { breakpointMobile } from './breakpoints';

interface OwnProps extends Omit<ButtonProps, 'classes'> {
  secondary?: boolean;
}

interface FooterButtonProps
  extends OwnProps,
    WithStyles<typeof styles | ButtonClassKey> {}

const FooterButtonBase: FunctionComponent<FooterButtonProps> = ({
  classes: { root: buttonClass, ...classes },
  secondary,
  ...props
}) => (
  <Button
    variant="contained"
    className={buttonClass}
    classes={classes}
    {...props}
    color={secondary ? 'secondary' : 'primary'}
  />
);

// styled
const styles: StyleRulesCallback<'root' | ButtonClassKey> = (
  theme: Theme,
): StyleRules<'root' | ButtonClassKey> =>
  // @ts-ignore
  deepmerge(
    buttonStyles(theme),
    createStyles({
      root: {
        flex: 'none',
        textTransform: 'none',
        margin: theme.spacing.unit,
        marginLeft: 0,
        marginRight: 0,
        [breakpointMobile(theme)]: {
          marginLeft: theme.spacing.unit,
          marginRight: theme.spacing.unit,
        },
      },
    }),
  );

export const FooterButton = withStyles(styles)<OwnProps>(FooterButtonBase);

FooterButton.displayName = 'FooterButton';
